import approveIcon from "@assets/SVG/approve.svg";
import deleteIcon from "@assets/SVG/delete.svg";
import rejectIcon from "@assets/SVG/reject.svg";

import { Icon } from "@iconify/react";
import { Alert, Button, Input, Modal, Typography, Select } from "antd";
import _ from "lodash";
import { useState } from "react";

const { Option } = Select;

interface SubmitConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (
    reviewNotes: string,
    status?: string,
    attenderName?: string
  ) => Promise<void> | void;
  type: "close"
}

export default function ClosedConfirmationModal({ open, onClose, onSubmit, type }: SubmitConfirmModalProps) {
  const [reviewNotes, setReviewNotes] = useState("");
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  function onCancelHandler() {
    if (error) {
      setError(false);
    }
    setStatus("");
    setValue("");
    setReviewNotes("");
    onClose();
  }

  function onReviewNotesChangeHandler(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (e.target.value.length > 0 && error && type !== 'close') {
      setError(false);
    }
    setReviewNotes(e.target.value);
  }

  function onValueChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
  }

  function onStatusChangeHandler(value: string | undefined) {
    if (value && error) {
      setError(false);
    }
    setStatus(value);
  }

  async function onSubmitHandler() {
    if (type === 'close' && (!status || status.trim().length === 0)) {
      setError(true);
      return;
    }

    setLoading(true);
    try {
      await onSubmit(status, value, reviewNotes);  
    } catch (err) {
      // TODO: handle error
    } finally {
      setLoading(false);
      setReviewNotes("");
      setStatus("");
      setValue("");
      onClose();
    }
  }

  return (
    <Modal
      title="Close Request"
      open={open}
      maskClosable={true}
      onCancel={onCancelHandler}
      centered
      width={420}
      footer={
        <div className="flex w-full justify-end mt-6">
          <Button
            type="default"
            onClick={onCancelHandler}
            className="mr-2"
          >
            No, Cancel
          </Button>
          <Button
            type="primary"
            onClick={onSubmitHandler}
          >
            {loading && (
              <Icon
                icon={"mdi:loading"}
                width="12"
                height="12"
                className="animate-spin mr-1"
              />
            )}
            Yes, Proceed
          </Button>
        </div>
      }
    >
      <div className="text-left space-y-4">
          <>
            <div>
              <Typography.Title level={5} className="mb-2">Status</Typography.Title>
              <Select
                className="w-full"
                placeholder="Select status"
                value={status || undefined}              
                onChange={onStatusChangeHandler}
                allowClear
              >
                <Option value="noShow">No Show</Option>
                <Option value="cancel">Cancel</Option>
                <Option value="complete">Complete</Option>
              </Select>
              {error && type === "close" && (
                <p className="text-xs text-[#FF3333] mt-1">
                  Status is required
                </p>
              )}
            </div>

            <div>
              <Typography.Title level={5} className="mb-2">Attender Name</Typography.Title>
              <Input
                className="w-full"
                placeholder="Enter the Attender name"
                name="attenderName"
                value={value}
                onChange={onValueChangeHandler}
              />
            </div>
          </>

        <div style={{paddingBottom:"20px"}}>
          <Typography.Title level={5} className="mb-2">
            Comment
          </Typography.Title>
          <Input.TextArea
            className="w-full"
            placeholder="Enter Reason"
            maxLength={5000}
            minLength={3}
            name="reviewNotes"
            value={reviewNotes}
            onChange={onReviewNotesChangeHandler}
            rows={4}
          />
        </div>
        <><Typography.Text>This will close all requests for passengers registered under the same guardian at once.</Typography.Text></>
      </div>
    </Modal>
  );
}